import { url as accountUrl } from '../index';
import ApiService from '@api/api-service';

export const url = `${accountUrl}/AddOrEditCustomerAddress`;
export default new ApiService(url);
